<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <el-form :model="notificationDetail" ref="notificationDetail" label-width="0px"
      class="demo-dynamic form-horizontal detailPage">
      <el-tabs type="border-card">
        <el-tab-pane :label="$t('message.' + langItem.langCode)" v-for="(langItem, index) in notificationDetail.langMaps"
          :key="index">
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label"> Title </label>
                <div class="col-sm-10">
                  <el-form-item :prop="'langMaps.' + index + '.title'" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }">
                    <el-input v-model="langItem.title" show-word-limit maxlength="30"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Content </label>
                <div class="col-sm-10">
                  <el-form-item :prop="'langMaps.' + index + '.content'" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }">
                    <el-input type="textarea" v-model="langItem.content" show-word-limit maxlength="300"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Action Type </label>
                <div class="col-sm-4">
                  <el-form-item prop="status" :rules="{
                    required: false,
                    message: $t('message.required'),
                    trigger: 'change',
                  }">
                    <el-select v-model="notificationDetail.type" @change="changeActionType"
                      v-bind:placeholder="$t('message.PleaseSelect')">
                      <el-option v-for="item in actionTypeObj" :disabled="!item.allow.includes(userRole) || item.disabled.includes(notificationDetail.pushStatus) " :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="col-sm-4" style="display: flex;">
                  <el-input disabled v-model="eventIda" v-if="notificationDetail.type != 10"></el-input>
                  <el-button
                    v-if="notificationDetail.pushStatus != 0 && notificationDetail.type == 3 && notificationDetail.showImportFileUrl"
                    style="margin-left: 15px;" size="small" type="primary" @click="exportFile">
                    Export File
                  </el-button>
                  <el-upload
                    v-if="(!notificationDetail.pushStatus || notificationDetail.pushStatus == 0) && notificationDetail.type == 10"
                    class="upload-demo" action="#" :multiple="false" :http-request="handleImport" :auto-upload="true"
                    accept=".xlsx, .xls" :show-file-list="false">
                    <el-button type="primary">
                      Upload Member ID excel
                    </el-button>
                  </el-upload>
                </div>
              </div>
              <div v-if="notificationDetail.type == 10 && (file || notificationDetail.showImportFileUrl)"
                class="form-group">
                <label class="col-sm-2 control-label"> File </label>
                <div class="col-sm-10">
                  <div style="display: flex;align-items: center;">
                    <div class="control-label" style="text-align:start;" v-if="file && file.name">{{ file.name }}</div>
                    <i @click="handleDeleteFile" style="padding-top: 7px;margin-left:10px;" class="el-icon-close" v-if="file && file.name"></i>
                    <a v-else :href="notificationDetail.showImportFileUrl">{{ notificationDetail.showImportFileUrl }}</a>
                  </div>
                </div>
              </div>

              <div class="form-group" v-if="notificationDetail.type == 2">
                <label class="col-sm-2 control-label"> Event </label>
                <div class="col-sm-10">
                  <el-form-item prop="eventId" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }">
                    <el-select v-model="notificationDetail.eventId" v-bind:placeholder="$t('message.PleaseSelect')">
                      <el-option v-for="item in eventList" :key="item.id" :label="item.title" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>


                </div>
              </div>
              <div class="form-group" v-if="notificationDetail.type != 3 && userRole == 0 && notificationDetail.pushStatus != 2">
                <label class="col-sm-2 control-label">
                  Notification time
                </label>

                <div class="col-sm-10">
                  <el-switch v-model="isNotification"></el-switch>
                </div>
              </div>
              <div class="form-group" v-if="isNotification">
                <label class="col-sm-2 control-label"> </label>
                <div class="col-sm-5">
                  <el-form-item prop="notificationDate" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'change',
                  }">
                    <el-date-picker v-model="notificationDetail.notificationDate" value-format="yyyy-MM-dd"
                      :picker-options="beginTimeOption" @change="changeDate" type="date">
                    </el-date-picker>
                  </el-form-item>
                </div>
                <div class="col-sm-5">
                  <el-form-item prop="time" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'change',
                  }">
                    <el-time-select v-model="notificationDetail.time" :picker-options="timeOption">
                    </el-time-select>
                  </el-form-item>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <p v-if="(notificationDetail.pushStatus == 0 || notificationDetail.pushStatus == null) &&
                        ((checkPermission('PUSH_LIST_EDIT') &&
                        $route.query.id) ||
                        (checkPermission('PUSH_LIST_ADD') && !$route.query.id))
                        && userRole === 0" style="transform: translateX(120px); font-weight: 700">
                Please note that for real-time push, the push msg will send out
                after tap the "save and publish" button
              </p>

              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <el-popconfirm title="Do you confirm the changes in this page?  button1: Yes   button2: Cancel"
                      @confirm="checkEvent()" v-if="(notificationDetail.pushStatus == 0 || notificationDetail.pushStatus == null) &&
                        ((checkPermission('PUSH_LIST_EDIT') &&
                        $route.query.id) ||
                        (checkPermission('PUSH_LIST_ADD') && !$route.query.id))
                        && userRole === 0
                        ">
                      <el-button slot="reference" style="margin-right:15px;" type="primary">Save and Publish</el-button>
                    </el-popconfirm>

                    <el-popconfirm title="Do you confirm the changes in this page?  button1: Yes   button2: Cancel"
                      @confirm="submitPush()" v-if="notificationDetail.pushStatus == null &&
                        ((checkPermission('PUSH_LIST_EDIT') &&
                        $route.query.id) ||
                        (checkPermission('PUSH_LIST_ADD') && !$route.query.id))
                        && [2,3].includes(userRole)
                        ">
                      <el-button slot="reference" style="margin-right:15px;" type="primary">Submit</el-button>
                    </el-popconfirm>

                    <el-popconfirm title="Do you confirm the changes in this page?  button1: Yes   button2: Cancel"
                      @confirm="apporvePush()" v-if="notificationDetail.pushStatus === 2 &&
                        ((checkPermission('PUSH_LIST_EDIT') &&
                        $route.query.id) ||
                        (checkPermission('PUSH_LIST_ADD') && !$route.query.id))
                        && userRole === 0
                        ">
                      <el-button slot="reference" style="margin-right:15px;" type="primary">Approve</el-button>
                    </el-popconfirm>

                    <el-popconfirm title="Do you confirm the changes in this page?  button1: Yes   button2: Cancel"
                      @confirm="rejectPush()" v-if="notificationDetail.pushStatus == 2 &&
                        ((checkPermission('PUSH_LIST_EDIT') &&
                        $route.query.id) ||
                        (checkPermission('PUSH_LIST_ADD') && !$route.query.id))
                        && userRole === 0
                        ">
                      <el-button slot="reference" style="margin-right:15px;" type="danger">Reject</el-button>
                    </el-popconfirm>

                    <el-button @click="showWarning()">{{
                      $t("message.Cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <el-dialog :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
      <el-input v-model="searchName" name="search"></el-input>
      <el-table :data="rows" border style="width: 100%" ref="multipleTable" highlight-current-row
        @current-change="rowshandleCurrentChange" @selection-change="handleSelectionChange" :fit="true"
        row-key="eventCode" :cell-class-name="cell">
        <el-table-column label="Event Name" :show-overflow-tooltip="true" min-width="200">
          <template slot-scope="scope">
            <div>
              <el-tag type="warning" effect="dark" size="mini" v-if="scope.row.expired">
                Expired
              </el-tag>
              {{ scope.row.title }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="categoryIds" :show-overflow-tooltip="true" label="Event Category"
          min-width="130"></el-table-column>
        <el-table-column prop="districtName" :show-overflow-tooltip="true" label="Event Direct"
          min-width="130"></el-table-column>
        <el-table-column prop="updatedAt" label="Last Update Time" width="170">
        </el-table-column>
      </el-table>
      <el-col :span="24" class="el-table_footertoolbar">
        <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" :total="total"
          style="float: right">
        </el-pagination>
      </el-col>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="dialogVisible = false">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import config from "../config";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      file: null,
      rows: [],
      page: 1, //当前页数
      pagesize: 10, //一页显示几条
      searchName: "",
      total: "",
      dialogVisible: false,
      notificationDetail: {
        langMaps: [],
        type: 10,
        category: [],
        actionType: null,
        status: 1,
        time: "",
        eventId: null,
        pushStatus:null
        // displayOrder:1
      },
      eventIda: "",
      eventCode: "",
      period: null,
      time: "",
      statusObj: [],
      eventList: [],
      actionTypeObj: [],
      isNotification: false,
      beginTimeOption: {
        disabledDate(date) {
          return date.getTime() <= new Date().getTime() - 24 * 60 * 60 * 1000;
        },
      },
      timeOption: {
        start: "00:00",
        step: "01:00",
        end: "23:00",
        minTime: "",
      },
    };
  },
  computed: {
    _language() {
      return this.$store.state.userInfo.langCode;
    },
    userRole(){
      // HQ admin 0
      // HQ editor 1
      // District admin 2
      // district editor 3
      const res =JSON.parse(sessionStorage.getItem("userInfo"));
      return res.roleType
    },
  },
  watch: {
    _language: function () {
      this.setObj();
    },
    notificationDetail: {
      handler: function () {
        this.$store.state.edit = true;
      },
      deep: true,
    },
  },
  
  created() {
    var obj = [];
    this.notificationDetail.type = [2,3].includes(this.userRole)?10:0
    for (var i = 0; i < this.$store.state.userInfo.language.length; i++) {
      obj.push({
        langCode: this.$store.state.userInfo.language[i].langCode,
        content: "",
        url: "",
        title: ''
      });
    }
    this.$set(this.notificationDetail, "langMaps", obj);
    this.init();
  },
  mounted() { },
  methods: {
    handleDeleteFile(){
      this.file = null
    },
    async exportFile() {
      if (!this.notificationDetail.showImportFileUrl) return;
      const xlsFileName =
        "Push Notification " +
        this.$dayjs(this.notificationDetail.notificationDate).format("YYYYMMDDHHmm") +
        ".xls";
      const url = this.notificationDetail.showImportFileUrl
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", xlsFileName);
      document.body.appendChild(link);
      link.click();
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getEventList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getEventList();
    },
    rowshandleCurrentChange(val) {
      this.eventIda = val.title;
      this.eventCode = val.eventCode;
    },
    cell: function ({ row }) {
      if (!this.canDrag) {
        return "disabled pointer";
      }
      // if (row.status == 1) {
      return "cursor-move";
      // } else {
      //   return "disabled pointer";
      // }
    },
    handleClose(done) {
      done();
    },
    addZero(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },
    myFunction() {
      var d = new Date();
      var h = this.addZero(d.getHours());
      var m = this.addZero(d.getMinutes());
      var s = this.addZero(d.getSeconds());
      return h + ":" + m + ":" + s;
    },
    changeDate() {
      var date = new Date();
      var year = date.getFullYear();
      var month = this.addZero(date.getMonth() + 1);
      var day = this.addZero(date.getDate());
      var today = year + "-" + month + "-" + day;
      if (this.notificationDetail.notificationDate == today) {
        this.timeOption.minTime = this.myFunction();
      } else {
        this.timeOption.minTime = "";
      }
    },
    setObj: function () {
      this.statusObj = [
        {
          value: 1,
          label: this.$i18n.t("message.Active"),
        },
        {
          value: 0,
          label: this.$i18n.t("message.Inactive"),
        },
      ];

      this.actionTypeObj = [
        {
          value: 0,
          label: "Broadcast message",
          allow:[0],
          disabled:[2]
        },
        {
          value: 3,
          label: "Register Event",
          allow:[0],
          disabled:[2]
        },
        {
          value: 10,
          label: "Batch Send",
          allow:[0,2,3],
          disabled:[]
        },
      ];
    },
    async init() {
      let id = this.$route.query.id;
      var that = this;
      if (id) {
        let obj = this.getAuthObj();
        obj.id = id;
        obj.apiUrl = this.apiConfig.pushNotificationDetail;
        let data = await this.$store.dispatch("apiEvent", obj);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        data.data.result.notificationDate = this.dateFormat(
          data.data.result.notificationDate
        );
        this.$set(this, "notificationDetail", data.data.result);
        if (this.notificationDetail.notificationDate) {
          var dateTime = this.notificationDetail.notificationDate.split(" ");
          this.notificationDetail.notificationDate = dateTime[0];
          this.notificationDetail.time = dateTime[1].substring(0, 5);
          this.isNotification = true;
        }
        this.changeDate();
        setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
      } else {
        setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
      }
      this.getEventList();
      this.setObj();
    },
    async getEventList() {
      var objdata = this.getAuthObj();

      objdata.pageIndex = this.pageIndex;
      objdata.pageSize = this.pagesize;
      objdata.sortName = "ASC";
      objdata.sortType = "sortOrder";
      objdata.status = 6;

      objdata.apiUrl = this.apiConfig.eventList;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.rows = data.data.result.events;
      this.total = data.data.result.total;
      this.$set(this, "eventList", data.data.result.events);
    },
    checkEvent: function () {
      this.$refs["notificationDetail"].validate((valid) => {
        if (valid) {
          if (this.notificationDetail.type == 10) this.handlePushNotificationCreatePushToPersonsSubmit()
          else this.submit();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    changeActionType(value) {
      if (value == 3) {
        this.getEventList();
        this.dialogVisible = true;
      } else {
        this.eventIda = ""
      }
      this.notificationDetail.eventId = "";
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function () {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
                that.callDelete();
              },
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function () {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
              },
            },
          ],
        });
      }
    },
    
    async submit() {
      try {
        let obj = this.getAuthObj();
        obj.notification = {
          status: this.notificationDetail.status,
          type: this.notificationDetail.type,
          //eventId: this.notificationDetail.eventId,
          langMaps: this.notificationDetail.langMaps,
          category: this.notificationDetail.category,
          eventId: this.eventCode,
        };
        if (this.isNotification) {
          if (!this.notificationDetail.time) {
            this.notificationDetail.time = "00:00";
          }
          this.notificationDetail.notificationDate +=
            " " + this.notificationDetail.time + ":00";
          obj.notification.notificationDate = new Date(
            this.notificationDetail.notificationDate
          ).getTime();
        } else {
          obj.notification.notificationDate = null;
        }
        var data;
        if (this.$route.query.id) {
          obj.notification.id = this.notificationDetail.id;
          obj.apiUrl = this.apiConfig.pushNotificationUpdate;
          data = await this.$store.dispatch("apiEvent", obj);
        } else {
          obj.apiUrl = this.apiConfig.pushNotificationCreate
          data = await this.$store.dispatch("apiEvent", obj);
        }
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$store.state.edit = false;
          this.$router.go(-1);
        }
      } catch (err) { }
    },

    async rejectPush() {
      try {
        let obj = this.getAuthObj();
        obj.id = this.notificationDetail.id
        var data;
        obj.apiUrl = this.apiConfig.rejectPushNotificationToPersons
        data = await this.$store.dispatch("apiEventFromData", obj);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$store.state.edit = false;
          this.$router.go(-1);
        }
      } catch (err) { console.log(err) }
    },

    async apporvePush() {
      try {
        let obj = this.getAuthObj();
        obj.contentEn = this.notificationDetail.langMaps[0].content
        obj.contentTc = this.notificationDetail.langMaps[2].content
        obj.contentSc = this.notificationDetail.langMaps[1].content
        obj.titleEn = this.notificationDetail.langMaps[0].title
        obj.titleTc = this.notificationDetail.langMaps[2].title
        obj.titleSc = this.notificationDetail.langMaps[1].title
        obj.id = this.notificationDetail.id
        var data;
        obj.apiUrl = this.apiConfig.apporvePushNotificationToPersons
        data = await this.$store.dispatch("apiEventFromData", obj);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$store.state.edit = false;
          this.$router.go(-1);
        }
      } catch (err) { console.log(err) }
    },

    async submitPush() {
      try {
        let obj = this.getAuthObj();
        obj.file = this.file
        obj.contentEn = this.notificationDetail.langMaps[0].content
        obj.contentTc = this.notificationDetail.langMaps[2].content
        obj.contentSc = this.notificationDetail.langMaps[1].content
        obj.titleEn = this.notificationDetail.langMaps[0].title
        obj.titleTc = this.notificationDetail.langMaps[2].title
        obj.titleSc = this.notificationDetail.langMaps[1].title

        var data;
        obj.apiUrl = this.apiConfig.submitPushNotificationToPersons
        data = await this.$store.dispatch("apiEventFromData", obj);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$store.state.edit = false;
          this.$router.go(-1);
        }
      } catch (err) { console.log(err) }
    },
    async handlePushNotificationCreatePushToPersonsSubmit() {
      try {
        let obj = this.getAuthObj();
        obj.file = this.file
        obj.contentEn = this.notificationDetail.langMaps[0].content
        obj.contentTc = this.notificationDetail.langMaps[2].content
        obj.contentSc = this.notificationDetail.langMaps[1].content
        obj.titleEn = this.notificationDetail.langMaps[0].title
        obj.titleTc = this.notificationDetail.langMaps[2].title
        obj.titleSc = this.notificationDetail.langMaps[1].title
        obj.id = this.notificationDetail.id || '';
        if (this.isNotification) {
          if (!this.notificationDetail.time) {
            this.notificationDetail.time = "00:00";
          }
          this.notificationDetail.notificationDate +=
            " " + this.notificationDetail.time + ":00";
          obj.notificationDate = new Date(
            this.notificationDetail.notificationDate
          ).getTime();
        } else {
          obj.notificationDate = null;
        }
        var data;
        obj.apiUrl = this.$route.query.id ? this.apiConfig.pushNotificationUodatePushToPersons : this.apiConfig.pushNotificationCreatePushToPersons
        data = await this.$store.dispatch("apiEventFromData", obj);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$store.state.edit = false;
          this.$router.go(-1);
        }
      } catch (err) { console.log(err) }
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {
      try {
        let obj = this.getAuthObj();
        obj.ids = this.$route.query.id;
        obj.apiUrl = this.apiConfig.pushNotificationDelete;
        var data = await this.$store.dispatch("apiEvent", obj);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$router.go(-1);
        }
      } catch (err) { }
    },
    async handleImport(params) {
      this.file = params.file;
    },
  },
};
</script>
